/**
 * Reforça o layout de formulário no coletor em runtime.
 *
 * Preferir sempre na página:
 * ```ts
 * definePageMeta({ layout: "collector-option" });
 * ```
 *
 * Este helper existe para telas legadas que ainda o chamam em `onBeforeMount`.
 * Em modo mobile/coletor aplica `collector-option` (topbar com voltar).
 *
 * @param mobile - `true` quando o dispositivo é coletor/mobile
 */
export default function useSetPageLayout(mobile?: boolean) {
	const pageStore = usePageStore();
	const emModoColetor = mobile === true || pageStore.isCollector();

	if (emModoColetor) {
		setPageLayout("collector-option");
	}
}
